import { forwardRef, type ElementType } from "react";

import { cx, styled } from "simplydo/react/styled";

import { boxShadowFor } from "../utils";
import { StyledTable } from "./Table.styles";
import type { TableProps } from "./Table.types";

const TableComponent = forwardRef<HTMLTableElement, TableProps>(
  (props, ref) => {
    const {
      id,
      as,
      celled,
      striped,
      compact,
      basic,
      collapsing,
      sortable,
      selectable,
      singleLine,
      fixed,
      padded,
      size,
      definition,
      structured,
      unstackable,
      textAlign,
      verticalAlign,
      className,
      style,
      children,
    } = props;

    const Component = (as || "table") as ElementType;
    const shadow = boxShadowFor({ elevation: "small" });

    return (
      <StyledTable
        ref={ref}
        id={id}
        as={Component}
        className={cx(
          className,
          celled && "celled",
          striped && "is-striped",
          compact && "compact",
          basic && "basic",
          collapsing && "is-collapsing",
          sortable && "is-sortable",
          selectable && "is-selectable",
          singleLine && "is-single-line",
          fixed && "fixed",
          size,
          definition && "is-definition",
          structured && "structured",
          unstackable && "unstackable",
        )}
        style={style}
        $shadow={shadow}
        $celled={celled}
        $compact={compact}
        $basic={basic}
        $padded={padded}
        $size={size}
        $fixed={fixed}
        $textAlign={textAlign}
        $verticalAlign={verticalAlign}
      >
        {children}
      </StyledTable>
    );
  },
);

TableComponent.displayName = "Table";

export const Table = styled(TableComponent)``;
